import React from "react";

const STEPS = [
  ["1 · Breed", "Our AI generates and mutates thousands of rule-based strategies (mean reversion, breakouts, trend pullbacks and more) across indices, FX and metals."],
  ["2 · Real-tick backtest", "Each candidate is tested in the MetaTrader 5 strategy tester on real broker tick data, Jan 2022 to Jan 2025, starting from £2,000 with realistic spreads."],
  ["3 · Walk-forward + robustness", "Contenders are checked on an unseen year, with doubled spreads, settings nudged ±20%, every year profitable on its own, and Monte Carlo trade shuffles for worst-case drawdown."],
  ["4 · 2025+ unseen-data backtest", "Finally, the bot is backtested on 2025+ data it wasn't built on. Bots with a positive result are also shown in a separate section with their full 2025+ results."],
];

export default function HowWeTest() {
  return (
    <section id="how-we-test" data-testid="how-we-test" className="relative z-10 max-w-[1400px] mx-auto px-6 pb-16 border-t border-blue-900/30 pt-16">
      <div className="mono text-[11px] uppercase tracking-[0.3em] text-[#D6FF38]">How we test</div>
      <h2 className="text-3xl font-medium tracking-tight mt-2">What the numbers mean - and what they don't.</h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-5 mt-8">
        {STEPS.map(([h, b]) => (
          <div key={h} className="border border-blue-900/40 bg-[#020617]/60 rounded-xl p-5">
            <div className="mono text-[11px] uppercase tracking-widest text-[#FBBF24]">{h}</div>
            <p className="text-sm text-[#94A3B8] mt-3 leading-relaxed">{b}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 border border-[#FBBF24]/30 bg-[#1A1405]/60 rounded-xl p-5 text-sm text-[#FDE68A] leading-relaxed" data-testid="how-we-test-caveat">
        <b>Please read:</b> backtests are simulations of the past. They do not include every real-world cost (slippage, requotes,
        swap changes, outages) and profits shown compound from £2,000, which makes later months look much larger. Results on the
        unseen 2025 data are usually far smaller than the 2022-2024 backtest. We never trade for you or manage your account, and none of this
        is a promise or a forecast. Strategies are fixed when released and aren't changed remotely while you use them.
      </div>
    </section>
  );
}
